// SEO Configuration for InitX Technologies
export const seoConfig = {
  // Default SEO settings
  defaultTitle: 'InitX Technologies - Leading Technology Solutions & Digital Innovation Platform',
  titleTemplate: '%s | InitX Technologies',
  defaultDescription: 'InitX Technologies is an IT consulting and software development company offering web development, software development, AI solutions, cloud services, and end-to-end digital transformation for startups and enterprises.',
  
  // Core tech company keywords
  coreKeywords: [
    'technology solutions', 'AI development', 'artificial intelligence', 'machine learning', 'deep learning', 'neural networks',
    'computer vision', 'natural language processing', 'predictive analytics', 'data science', 'big data analytics',
    'cloud computing', 'cloud infrastructure', 'cloud migration', 'serverless computing', 'edge computing',
    'web development', 'React development', 'Vue.js development', 'Angular development', 'Node.js development',
    'Python development', 'Java development', 'PHP development', '.NET development', 'Ruby on Rails',
    'mobile app development', 'iOS development', 'Android development', 'React Native', 'Flutter development',
    'Xamarin development', 'cross-platform apps', 'native mobile apps', 'progressive web apps',
    'digital transformation', 'enterprise solutions', 'startup technology', 'tech consulting', 'software engineering',
    'custom software development', 'software architecture', 'system design', 'technical consulting',
    'DevOps services', 'CI/CD pipeline', 'continuous integration', 'continuous deployment', 'containerization',
    'Docker', 'Kubernetes', 'microservices architecture', 'serverless architecture', 'infrastructure as code',
    'cybersecurity solutions', 'penetration testing', 'security audit', 'vulnerability assessment', 'compliance consulting',
    'API development', 'REST API', 'GraphQL', 'SOAP services', 'webhook development', 'third-party integrations',
    'database design', 'MongoDB', 'PostgreSQL', 'MySQL', 'Redis', 'Elasticsearch', 'data modeling',
    'blockchain development', 'cryptocurrency', 'smart contracts', 'DeFi solutions', 'NFT development', 'Web3',
    'IoT solutions', 'Internet of Things', 'embedded systems', 'sensor networks', 'industrial IoT',
    'automation solutions', 'RPA', 'robotic process automation', 'workflow automation', 'business process automation',
    'tech innovation', 'emerging technologies', 'digital solutions', 'technology consulting', 'IT services',
    'managed services', 'cloud consulting', 'digital strategy', 'technology roadmap', 'innovation consulting'
  ],
  
  // Page-specific SEO configurations
  pages: {
    home: {
      title: 'InitX Technologies | Custom Software Development & IT Consulting',
      description: 'InitX Technologies provides expert custom software development, mobile apps, and IT consulting for startups and enterprises. Build scalable, high-performance digital products today.',
      keywords: 'custom software development, IT consulting, mobile app development, web development, software solutions, digital transformation, enterprise software, startup technology, scalable applications, high-performance software',
      schema: 'WebPage'
    },
    
    about: {
      title: 'About InitX Technologies - Innovation Team & Company',
      description: 'Learn about InitX Technologies, a leading technology company specializing in AI, cloud solutions, and digital transformation. Meet our expert team of engineers and consultants.',
      keywords: 'about InitX Technologies, technology company, AI experts, cloud specialists, software engineers, tech team, innovation, digital transformation experts, technology consulting',
      schema: 'AboutPage'
    },
    
    services: {
      title: 'Tech Services - AI, Cloud, Web Dev | InitX Technologies',
      description: 'Expert technology services: AI development, cloud solutions, web development, mobile apps, DevOps, and cybersecurity for enterprises and startups.',
      keywords: 'technology services, AI development services, cloud solutions, web development company, mobile app development, DevOps services, cybersecurity solutions, tech consulting, software engineering',
      schema: 'Service'
    },
    
    products: {
      title: 'Tech Products - Software Solutions | InitX Technologies',
      description: 'Cutting-edge software products and digital solutions to transform business operations and accelerate growth. Custom enterprise applications.',
      keywords: 'technology products, software solutions, digital products, business software, enterprise applications, custom solutions, tech products',
      schema: 'Product'
    },
    
    blogs: {
      title: 'Tech Blog - AI, Cloud, Development | InitX Technologies',
      description: 'Latest technology trends, AI developments, cloud computing insights, and software engineering best practices from InitX Technologies experts.',
      keywords: 'technology blog, AI trends, cloud computing, software development, tech insights, programming tutorials, technology news, development best practices',
      schema: 'Blog'
    },
    
    careers: {
      title: 'Careers at InitX Technologies - Join Our Technology Team',
      description: 'Join our innovative technology team. Career opportunities in AI development, cloud engineering, software development, and tech consulting.',
      keywords: 'InitX Technologies careers, technology jobs, AI developer jobs, cloud engineer positions, software engineer careers, tech consulting jobs, remote tech jobs, startup careers',
      schema: 'JobPosting'
    },
    
    contact: {
      title: 'Contact InitX Technologies - Tech Solutions & Consulting',
      description: 'Contact InitX Technologies for AI development, cloud services, and digital transformation consulting. Free consultation with tech experts.',
      keywords: 'contact InitX Technologies, technology consulting, AI development consultation, cloud solutions, tech support, digital transformation, free consultation, technology experts',
      schema: 'ContactPage'
    }

  },
  
  // Industry-specific keywords
  industries: {
    fintech: ['fintech solutions', 'financial technology', 'banking software', 'payment systems', 'blockchain finance'],
    healthcare: ['healthcare technology', 'medical software', 'telemedicine', 'health analytics', 'HIPAA compliance'],
    ecommerce: ['e-commerce platform', 'online marketplace', 'retail technology', 'shopping cart', 'payment gateway'],
    education: ['edtech solutions', 'learning management system', 'educational software', 'online learning platform'],
    logistics: ['logistics software', 'supply chain management', 'inventory management', 'tracking systems'],
    manufacturing: ['manufacturing software', 'industrial IoT', 'automation systems', 'quality management']
  },
  
  // Technology stack keywords
  technologies: {
    frontend: ['React', 'Vue.js', 'Angular', 'Next.js', 'TypeScript', 'JavaScript', 'HTML5', 'CSS3', 'Sass'],
    backend: ['Node.js', 'Python', 'Django', 'Flask', 'Express.js', 'Java', 'Spring Boot', 'PHP', 'Laravel'],
    mobile: ['React Native', 'Flutter', 'iOS', 'Android', 'Xamarin', 'Ionic', 'Swift', 'Kotlin'],
    cloud: ['AWS', 'Azure', 'Google Cloud', 'Docker', 'Kubernetes', 'Serverless', 'Lambda', 'CloudFormation'],
    database: ['MongoDB', 'PostgreSQL', 'MySQL', 'Redis', 'Elasticsearch', 'DynamoDB', 'Firebase'],
    ai: ['TensorFlow', 'PyTorch', 'OpenAI', 'Natural Language Processing', 'Computer Vision', 'Deep Learning']
  },
  
  // Social media handles
  social: {
    twitter: '@initxtech',
    linkedin: 'initx-technologies',
    github: 'initxtech',
    youtube: 'c/initxtech',
    facebook: 'initxtech',
    instagram: 'initxtech'
  },
  
  // Company information
  company: {
    name: 'InitX Technologies',
    shortName: 'InitX',
    founded: '2021',
    location: 'Sasaram, Bihar & Lucknow, Uttar Pradesh, India',
    phone: '+91-8469718513',
    email: 'contact@initx.online',
    website: 'https://initx.online'
  },
  
  // OpenGraph defaults
  openGraph: {
    type: 'website',
    locale: 'en_US',
    siteName: 'InitX Technologies',
    images: [
      {
        url: '/og-image.jpg',
        width: 1200,
        height: 630,
        alt: 'InitX Technologies'
      }
    ]
  },
  
  // Twitter Card defaults
  twitter: {
    cardType: 'summary_large_image',
    site: '@initxtech',
    creator: '@initxtech'
  }
};

// Helper function to generate page-specific SEO data
export const generateSEOData = (pageKey, customData = {}) => {
  const pageConfig = seoConfig.pages[pageKey] || seoConfig.pages.home;
  
  return {
    title: customData.title || pageConfig.title,
    description: customData.description || pageConfig.description,
    keywords: customData.keywords || pageConfig.keywords,
    ...customData
  };
};

// Helper function to combine keywords
export const combineKeywords = (...keywordArrays) => {
  return keywordArrays.flat().join(', ');
};

export default seoConfig;
